import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import Checkmark from '../../icons/checkmark.svg';

const FormSuccess = (props) => {
  const wrapperRef = useRef();

  useEffect(() => {
    wrapperRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const { title, content, children, showCheckMark = true } = props;

  return (
    <FormSuccessStyle ref={wrapperRef}>
      <Title>{title}</Title>
      {showCheckMark && (
        <Success>
          <StyledCheckmark />
        </Success>
      )}
      <Content dangerouslySetInnerHTML={{ __html: content }} />
      {children}
    </FormSuccessStyle>
  );
};

const FormSuccessStyle = styled.div`
  text-align: center;
  padding: 0 20px 0px;
`;

const Title = styled.h5`
  font-size: var(--heading-size-xl);
  font-weight: var(--font-weight-black);
  line-height: var(--line-height-sm);
  color: var(--blue-dark);
  margin-bottom: 50px;
`;

const Content = styled.p`
  font-size: var(--font-size-lg);

  max-width: 510px;
  margin: 0 auto 50px;
`;

const Success = styled.div`
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: rgb(234, 252, 248);
  margin: 0 auto 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledCheckmark = styled(Checkmark)`
  width: 50px;
  height: 50px;
  path {
    fill: rgb(63, 204, 175);
  }
`;
export default FormSuccess;
